import React from "react";
import { Link } from "react-router-dom";

export default function PostCard({ post }) {
    return (
        <Link to={`/posts/${post?.id}`} className="text-decoration-none">
            <div className="card shadow-sm">
                <img className="card-img-top" src={post?.imageURL} alt="Post" />
                <div className="card-body">
                    <h5 className="card-title">{post?.title}</h5>
                    <p className="card-text text-muted small">{new Date(post?.timestamp?.toDate()).toLocaleDateString()}</p>
                </div>
            </div>
        </Link>
    );
}
